<div class="main-container">
	<div class="document-view-container">
		<ng-container *ngIf="isDataLoading">
			<app-loader [isInline]="true" *ngIf="isDataLoading" [matIconFailed]="'error_outline'"></app-loader>
		</ng-container>
		<ng-container *ngIf="!isDataLoading">
			<app-document-viewer [documentDetails]="this.documentDetails"
				[afterWebViewerRender]="afterWebViewerRender.bind(self)">
			</app-document-viewer>
		</ng-container>
	</div>
</div>

<generic-modal #manageDocumentModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading>
		<div *ngIf="managedJobDocuments || isGuest">
			<h3>Manage Document</h3>
			<h3 style="font-size: 14px;" *ngIf="isGuest">as Guest</h3>
			<h3 style="font-size: 14px;" *ngIf="!isGuest && !!managedJobDocuments">as {{managedJobDocuments.userName}}
				({{managedJobDocuments.cloudUserType}} for {{managedJobDocuments.accountName}}) </h3>
		</div>
		<button mat-flat-button (click)="onClose()" class="close-button">
			<mat-icon>close</mat-icon>
		</button>
	</ng-template>

	<ng-template #modalBody>
		<div class="main-container lg-view" style="position:relative">
			<app-loader [isInline]="true" *ngIf="isLoading && !managedJobDocuments"
				[loaderMessage]="'Loading...'"></app-loader>
			<mat-tab-group *ngIf="!permissionDenied && !!managedJobDocuments" mat-stretch-tabs="false" mat-align-tabs="start"
				(selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedTabIndex">
				<mat-tab label="Job Documents" *ngIf="!selectedJobDocument && !isOnAddClassification"
					(click)="onTabClick()" [disabled]="isUnsavedWork">
					<app-loader [isInline]="true" *ngIf="isLoading"
						[hasTransparency]="(selectedJobDocument || isOnAddClassification) && isUnsavedWork"
						[loaderMessage]="'Loading...'"></app-loader>
					<ng-container *ngIf="!isLoading">
						<div class="classification-actions" *ngIf="managedJobDocuments.canAddJobDocument">
							<button mat-raised-button (click)="onAddJobDocumentClick()" class="add-classification">
								<mat-icon>add</mat-icon> Add Classification
							</button>
						</div>
						<div class="job-documents">
							<ng-container *ngFor="let j of managedJobDocuments.managedJobDocuments">
								<div>
									<div class='job-details'>
										<div>
											<div>
												<span><strong>{{j.jobName}}</strong></span>
												<span> / </span>
												<span>{{j.projectName}}</span>
											</div>
											<div class='job-details__row'>
												<div class='job-row__label'>Site:</div>
												<div class='job-row__info'>{{j.siteName}} - {{j.accountName}}</div>
											</div>
											<div class='job-details__row'>
												<div class='job-row__label'>Asset:</div>
												<div class='job-row__info'>
													{{j.assetName}}
												</div>
											</div>
											<div class='job-details__row'>
												<div class='job-row__label'>Document Type:</div>
												<div class='job-row__info'>
													{{j.documentTypeName}}
												</div>
											</div>
											<div class='job-details__row'>
												<div class='job-row__label'>Effective Date:</div>
												<div class='job-row__info'>
													{{(j.effectiveDate &&
													moment.parseZone(j.effectiveDate).format('MM/DD/YYYY')) || ''}}
												</div>
											</div>
											<div class='checkbox-require-docs-wrapper'>
												<span class='conclusion-option'>{{j.documentConclusionOption}}</span>
												<span *ngIf="j.requiresAdditionalDocumentation"
													[class.no-additional-doc]="j.additionalDocIds.length === 0"
													class="additional-docs-count">({{getRequireAdditionalDocsMsg(j.additionalDocIds.length)}})</span>
												<span *ngIf="!j.requiresAdditionalDocumentation"
													class="additional-docs-count empty"></span>
											</div>
											<div class='job-details__row' *ngIf="j.isReviewRequired">
												<mat-checkbox class="job-checkbox-info" [disabled]="true"
													[(ngModel)]="j.isReviewed">Document is reviewed</mat-checkbox>
											</div>
											<div class='binders-wrapper'>
												<strong>Binders:</strong>
												<div class='job-binders'>
													<div>
														<ul *ngIf="!!j.binders && j.binders.length > 0">
															<li *ngFor="let binder of groupBinderTabs(j.binders)">
																<span>{{binder.binderTemplateName}}: </span>
																<ul style="padding-inline-start: 30px;">
																	<li *ngFor="let binderTab of binder.tabs">
																		<span>{{binderTab.binderTabName}}</span>
																	</li>
																</ul>
															</li>
														</ul>
														<span *ngIf="!j.binders || j.binders.length === 0">No
															binders.</span>
													</div>
												</div>
											</div>
										</div>
										<!-- <div>
											<Tooltip title='Edit'>
												<Button style={{ marginRight: 4 }} icon='edit' type='link' size='small'
													onClick={() => onEditClassification(j)} />
											</Tooltip>
											<Tooltip title='Remove'>
												<Button icon='delete' type='danger' size='small' onClick={() => onHide(`${j.JobName} - ${j.ProjectName}`, j)} />
											</Tooltip>
										</div> -->
									</div>
									<div class="actions">
										<button mat-mini-fab color="primary" aria-label="Edit Job Document"
											(click)="editManagedJobDocument(j)" class="edit-button">
											<mat-icon *ngIf="j.canEdit">edit</mat-icon>
											<mat-icon *ngIf="!j.canEdit">visibility</mat-icon>
										</button>
										<button mat-mini-fab color="primary" aria-label="Delete Job Document"
											*ngIf="j.canDelete" (click)="deleteManagedJobDocument(j)"
											class="edit-button">
											<mat-icon *ngIf="j.canDelete">delete</mat-icon>
										</button>
									</div>
								</div>
							</ng-container>
						</div>
					</ng-container>
				</mat-tab>
				<mat-tab *ngIf="!!selectedJobDocument || isOnAddClassification" [disabled]="isUnsavedWork">
					<ng-template mat-tab-label>
						<div *ngIf="isUnsavedWork && !isOnAddClassification" class="tab-label" (click)="onTabClick()">
							<span>Details</span>
						</div>
						<span *ngIf="!isUnsavedWork && !isOnAddClassification">Details</span>
						<span *ngIf="isOnAddClassification">Add Classification</span>
					</ng-template>
					<mat-sidenav-container class="document-selection">
						<mat-sidenav #sidenav disableClose position="end">
							<app-loader [isInline]="true" *ngIf="isLoading" [loaderMessage]="'Loading...'"></app-loader>
							<div class="drawer-body">
								<mat-expansion-panel>
									<mat-expansion-panel-header>
										<mat-panel-title>
											Filter Documents
										</mat-panel-title>
									</mat-expansion-panel-header>
									<div class="document-details">
										<form [formGroup]="filterDocumentsForm">
											<mat-form-field>
												<mat-label>Document Name</mat-label>
												<input matInput formControlName="name">
											</mat-form-field>
											<mat-form-field>
												<mat-label>Document Type</mat-label>
												<mat-select formControlName="documentTypeId">
													<mat-option *ngFor="let doc of documentTypes" [value]="doc.id">
														{{doc.name}}
													</mat-option>
												</mat-select>
											</mat-form-field>
											<mat-form-field class="calendar" [floatLabel]="'always'">
												<mat-label>Effective Date</mat-label>
												<input matInput [matDatepicker]="documentPicker"
													formControlName="effectiveDate">
												<mat-datepicker-toggle matSuffix
													[for]="documentPicker"></mat-datepicker-toggle>
												<mat-datepicker #documentPicker></mat-datepicker>
												<button mat-button
													*ngIf="filterDocumentsForm.get('effectiveDate')?.value" matSuffix
													mat-icon-button aria-label="Clear" (click)="onDateSearchClear()">
													<mat-icon>close</mat-icon>
												</button>
											</mat-form-field>
										</form>
									</div>
								</mat-expansion-panel>
								<div class="document-list">
									<ng-container *ngIf="jobDocuments?.length">
										<form [formGroup]="additionalDocumentsForm">
											<div formArrayName="additionalDocs">
												<div *ngIf="selectedJobDocument?.canEdit || isOnAddClassification"
													class="all-documents-selected">
													<mat-checkbox (change)="onAllDocumentsSelected($event)">
													</mat-checkbox>
													<span class="bold">Document</span>
												</div>
												<div class="document-container"
													*ngFor="let item of additionalDocs.controls; let i = index"
													[formGroupName]="i">

													<mat-checkbox
														*ngIf="selectedJobDocument?.canEdit || isOnAddClassification"
														formControlName="isIncluded">
													</mat-checkbox>
													<div class="details"
														[ngClass]="{'view-only': !selectedJobDocument?.canEdit}">
														<span class="grey">{{item.get('name').value}}</span>
														<div>
															<span *ngIf="item.get('effectiveDate')?.value !== null">
																{{moment(item.get('effectiveDate').value).format('MM/DD/YYYY')}}
															</span>
															<span *ngIf="item.get('effectiveDate')?.value === null">
																n/a
															</span>
															<span>
																{{item.get('documentTypeName').value}}
															</span>
														</div>
													</div>
												</div>
											</div>
										</form>
									</ng-container>
									<ng-container *ngIf="jobDocuments === null">
										<span>No Documents</span>
									</ng-container>
								</div>
							</div>
							<div class="drawer-footer">
								<div class="buttons">
									<button type="button" mat-raised-button (click)="onDocumentSelectionClose()">
										<span *ngIf="selectedJobDocument?.canEdit">Close</span>
										<span *ngIf="!selectedJobDocument?.canEdit">Back</span>
									</button>
								</div>
							</div>
						</mat-sidenav>
						<mat-sidenav-content>
							<app-loader [isInline]="true" *ngIf="isLoading"
								[hasTransparency]="(selectedJobDocument || isOnAddClassification) && isUnsavedWork"
								[loaderMessage]="'Loading...'"></app-loader>
							<div class="main-form" *ngIf="!isOnAddClassification">
								<form [formGroup]="jobDocumentFormGroup">
									<div class="form-field"
										*ngIf="classificationDocumentTypes?.length === 1 || !selectedJobDocument?.canEdit">
										<span class="bold">Document Type: </span>
										<span class="">
											{{jobDocumentFormGroup.get('documentTypeName').value}}
										</span>
									</div>
									<div class="form-field document-type"
										*ngIf="classificationDocumentTypes?.length > 1 && selectedJobDocument?.canEdit">
										<span class="bold">Document Type: </span>
										<mat-form-field>
											<mat-select formControlName="documentClassAndTypeMappingId">
												<mat-option *ngFor="let doc of classificationDocumentTypes"
													[value]="doc" (click)="onDocTypeChange(doc)">
													{{doc.name}}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="form-field" *ngIf="!isOnAddClassification">
										<span class="bold">Site: </span>
										<span class="">
											{{selectedJobDocument.siteName}} - {{selectedJobDocument?.accountName}}
										</span>
									</div>
									<div class="form-field" *ngIf="!isOnAddClassification">
										<span class="bold">Asset: </span>
										<span class="">
											{{selectedJobDocument?.assetName}}
										</span>
									</div>
									<div class="form-field">
										<span class="bold col-md-3">Effective Date: </span>
										<span class=""
											*ngIf="!selectedJobDocument?.canEdit">{{(jobDocumentFormGroup.get('effectiveDate').value
											&&
											moment.parseZone(jobDocumentFormGroup.get('effectiveDate').value).format('MM/DD/YYYY'))
											|| ''}}
										</span>
										<mat-form-field *ngIf="selectedJobDocument?.canEdit" class="calendar"
											[floatLabel]="'always'">
											<input matInput [matDatepicker]="picker" formControlName="effectiveDate">
											<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
											<mat-datepicker #picker></mat-datepicker>
										</mat-form-field>
									</div>
									<div class="form-field">
										<span class="bold">Document Name: </span>
										<span>
											{{jobDocumentFormGroup.get('fileName').value}}
										</span>
									</div>
									<div class="form-field conclusion-select">
										<span class="bold">Conclusion: </span>
										<span class="" *ngIf="!selectedJobDocument?.canEdit">
											{{getConclusion(jobDocumentFormGroup.get('documentConclusionOptionId').value)}}
										</span>
										<mat-form-field *ngIf="selectedJobDocument?.canEdit">
											<mat-select formControlName="documentConclusionOptionId">
												<mat-option *ngFor="let doc of documentConclusionOptions"
													[value]="doc.documentConclusionOptionId"
													(click)="onDocOptionChange(doc.documentConclusionOptionId)"
													[class.obsolete]="doc.isSameGroup" [disabled]="doc.isSameGroup">
													{{doc.name}}
												</mat-option>
											</mat-select>
										</mat-form-field>
										<button *ngIf="documentConclusionOptionSameGroupId !== null"
											class="option-warning" mat-icon-button
											matTooltip="This conclusion option is not valid anymore.">
											<mat-icon>warning</mat-icon>
										</button>
									</div>
									<div class="form-field">
										<div class="inline-field">
											<span
												*ngIf="jobDocumentFormGroup.get('requiresAdditionalDocumentation').value && jobDocumentFormGroup.get('documentConclusionOptionId').value !== documentConclusionOptionSameGroupId">
												<span *ngIf="selectedJobDocumentsCount === 0
													&& jobDocumentFormGroup.get('requiresAdditionalDocumentation').value" class="grey">(no additional
													doc(s))</span>
												<span
													*ngIf="selectedJobDocumentsCount !== 0 && additionalDocs.controls.length !== 0"
													class="selected-documents">(
													{{selectedJobDocumentsCount}} additional doc(s)
													)
												</span>
											</span>
											<button
												*ngIf="jobDocumentFormGroup.get('requiresAdditionalDocumentation').value  && jobDocumentFormGroup.get('documentConclusionOptionId').value !== documentConclusionOptionSameGroupId"
												mat-icon-button (click)="onDrawerExpanded()"
												[disabled]="selectedJobDocumentsCount == 0 && !selectedJobDocument?.canEdit">
												<mat-icon *ngIf="selectedJobDocument?.canEdit">border_color</mat-icon>
												<mat-icon
													*ngIf="!selectedJobDocument?.canEdit && selectedJobDocumentsCount > 0">visibility</mat-icon>
											</button>
										</div>
									</div>
									<div class="form-field"
										*ngIf="selectedJobDocument.isReviewRequired || isManagedJobDocumentReviewRequired">
										<div class="inline-field">
											<span class="bold">Document Is Reviewed: </span>
											<mat-checkbox *ngIf="!selectedJobDocument?.canEdit" [disabled]="true"
												class="" [checked]="isReviewed"></mat-checkbox>
											<mat-checkbox *ngIf="selectedJobDocument?.canEdit" class=""
												formControlName="isReviewed"></mat-checkbox>
										</div>
									</div>
								</form>
							</div>

							<div *ngIf="isOnAddClassification" class="main-form">
								<form [formGroup]="addClassificationForm">
									<div class="form-field add-classification" *ngIf="isOnAddClassification">
										<span class="bold">Site: </span>
										<mat-form-field *ngIf="isOnAddClassification">
											<mat-select formControlName="site">
												<mat-option *ngFor="let site of addClassificationSites" [value]="site">
													{{site.name}}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="form-field add-classification" *ngIf="isOnAddClassification">
										<span class="bold">Asset: </span>
										<mat-form-field *ngIf="isOnAddClassification">
											<mat-select formControlName="asset">
												<mat-option *ngFor="let asset of addClassificationSiteAssets"
													[value]="asset.id">
													{{asset.name}}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="form-field add-classification">
										<span class="bold">Document Type: </span>
										<mat-form-field *ngIf="isOnAddClassification">
											<mat-select formControlName="documentType">
												<mat-option *ngFor="let doc of classificationDocumentTypes"
													[value]="doc" (click)="onAddClassificationDocTypeChange(doc)">
													{{doc.name}}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="form-field">
										<span class="bold">Repository:</span>
										<span *ngIf="addClassificationJob">{{addClassificationJob?.name}}</span>
										<span *ngIf="!addClassificationJob &&
												!addClassificationForm.get('site')?.value ||
												!addClassificationForm.get('asset')?.value ||
												!addClassificationForm.get('documentType')?.value
												">
											Please select a value for Site, Asset and Document Type
										</span>
										<span class="bold red" *ngIf="addClassificationForm.get('site')?.value &&
												addClassificationForm.get('asset')?.value &&
												addClassificationForm.get('documentType')?.value &&
												!addClassificationJob">
											No Job found for the selected values.
										</span>
									</div>
									<div class="form-field">
										<span class="bold col-md-3">Effective Date: </span>
										<mat-form-field class="calendar" [floatLabel]="'always'">
											<input matInput [matDatepicker]="picker" formControlName="effectiveDate">
											<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
											<mat-datepicker #picker></mat-datepicker>
										</mat-form-field>
									</div>

									<div class="form-field conclusion-select">
										<span class="bold">Conclusion: </span>
										<mat-form-field>
											<mat-select formControlName="documentConclusionOptionId">
												<mat-option *ngFor="let doc of documentConclusionOptions"
													[value]="doc.documentConclusionOptionId"
													(click)="onDocOptionChange(doc.documentConclusionOptionId)">
													{{doc.name}}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="form-field">
										<div class="inline-field">
											<span
												*ngIf="addClassificationForm.get('requiresAdditionalDocumentation').value && !!addClassificationForm.get('documentConclusionOptionId').value">
												<span *ngIf="selectedJobDocumentsCount === 0" class="grey">(no
													additional
													doc(s))</span>
												<span
													*ngIf="selectedJobDocumentsCount !== 0 && additionalDocs.controls.length !== 0"
													class="selected-documents">(
													{{selectedJobDocumentsCount}} additional doc(s)
													)
												</span>
											</span>
											<button
												*ngIf="addClassificationForm.get('requiresAdditionalDocumentation').value && !!addClassificationForm.get('documentConclusionOptionId').value"
												mat-icon-button (click)="onDrawerExpanded()">
												<mat-icon>border_color</mat-icon>
											</button>
										</div>
									</div>
									<div class="form-field" *ngIf="isManagedJobDocumentReviewRequired">
										<div class="inline-field">
											<span class="bold">Document Is Reviewed: </span>
											<mat-checkbox formControlName="isReviewed"></mat-checkbox>
										</div>
									</div>
								</form>
							</div>
						</mat-sidenav-content>
					</mat-sidenav-container>
				</mat-tab>
				<mat-tab label="Threads" *ngIf="managedJobDocuments.canManageFollowUps"
					#threadTab [disabled]="isUnsavedWork">
					<ng-template mat-tab-label>
						<div *ngIf="isUnsavedWork" class="tab-label" (click)="onTabClick()">
							<span>Threads</span>
						</div>
						<span *ngIf="!isUnsavedWork">Threads</span>
					</ng-template>
					<app-loader [isInline]="true" *ngIf="isLoading" [loaderMessage]="'Loading...'"
						[hasTransparency]="true"></app-loader>
					<mat-sidenav-container>
						<mat-sidenav #threadSidenav disableClose position="end" class="follow-up-tab">
							<ng-container *ngIf="!isOnCompleteFollowUp">
								<div class="follow-up-edit">
									<div>
										<h3 [class.completed]="selectedThread?.isCompleted">
											<span *ngIf="!selectedThread">
												New Thread Item
											</span>
											<span *ngIf="selectedThread">
												Thread
											</span>
											<span *ngIf="selectedThread?.isCompleted">- Completed</span>
											<span
												*ngIf="!selectedThread?.isCompleted && selectedThread?.threadTypeId === 3">-
												Open</span>
										</h3>
									</div>

									<form class="main-form" style="overflow: auto;" [formGroup]="supportOutForm" *ngIf="selectedThread?.threadTypeId === 5">
										<div class="note">
											<mat-form-field class="container column" style="padding-top: 15px" [disabled]="true">
												<mat-label>Support Out Request:</mat-label>
												<textarea rows="10" matInput formControlName="supportOutRequest"></textarea>
											</mat-form-field>
										</div>

										<div *ngIf="selectedThread" class="thread-type">
											<span class="bold">Type:</span>
											<span>{{threadForm.get('threadTypeName').value}}</span>
										</div>

										<div class="note">
											<mat-form-field class="container column" [floatLabel]="'always'"
												[disabled]="selectedThread?.isAcknowledged">
												<mat-label>Response:</mat-label>
												<textarea rows="5" matInput
													formControlName="supportOutResponse"></textarea>
											</mat-form-field>
										</div>

									</form>

									<form class="main-form" style="overflow: auto;" [formGroup]="threadForm" *ngIf="selectedThread?.threadTypeId !== 5">
										<mat-form-field class="container column">
											<mat-label>Note:</mat-label>
											<textarea rows="10" matInput formControlName="description"></textarea>
										</mat-form-field>

										<mat-form-field appearance="fill" *ngIf="!selectedThread">
											<mat-label>Additional action:</mat-label>
											<mat-select formControlName="threadTypeId"
												(selectionChange)="onThreadTypeChange($event)">
												<mat-option *ngFor="let type of threadTypes"
													[value]="type.id">{{type?.name}}</mat-option>
											</mat-select>
										</mat-form-field>
										<div *ngIf="selectedThread" class="thread-type">
											<span class="bold">Type:</span>
											<span>{{threadForm.get('threadTypeName').value}}</span>
										</div>

										<div *ngIf="selectedThread?.threadTypeId === 3 && selectedThread?.isCompleted"
											class="note">
											<mat-form-field class="container column"
												[disabled]="true">
												<mat-label>Response:</mat-label>
												<textarea rows="5" matInput
													formControlName="completedComment"></textarea>
											</mat-form-field>
										</div>

										<ng-container
											*ngIf="selectedThread?.threadTypeId === 2 || threadForm.get('threadTypeId').value === 2">
											<div class="form-field">
												<mat-form-field class="calendar" [floatLabel]="'always'"
													[disabled]="selectedThread?.isCompleted">
													<mat-label>Follow Up Date:</mat-label>
													<input matInput [matDatepicker]="picker"
														formControlName="followUpBy" [min]="today">
													<mat-datepicker-toggle matSuffix
														[for]="picker"></mat-datepicker-toggle>
													<mat-datepicker #picker></mat-datepicker>
												</mat-form-field>
											</div>
											<mat-form-field appearance="fill" [disabled]="selectedThread?.isCompleted" [floatLabel]="'always'">
												<mat-label>Notify Users</mat-label>
												<mat-select formControlName="notifyUsers" multiple>
													<mat-option *ngFor="let user of notifyUsers"
														[value]="user">{{user?.name}}</mat-option>
												</mat-select>
											</mat-form-field>

											<div *ngIf="selectedThread?.isCompleted" class="note">
												<mat-form-field class="container column"
													[disabled]="selectedThread?.isCompleted">
													<mat-label>Completed Comment:</mat-label>
													<textarea rows="5" matInput
														formControlName="completedComment"></textarea>
												</mat-form-field>
											</div>
										</ng-container>
									</form>
									<div class="actions">
										<div class="buttons">
											<button type="button" mat-raised-button (click)="onThreadCancel()"
												*ngIf="!selectedThread?.isCompleted">Cancel</button>
											<button type="button" mat-raised-button (click)="onThreadCancel()"
												*ngIf="selectedThread?.isCompleted">Close</button>
											<button type="submit" mat-raised-button (click)="onThreadSave()"
												*ngIf="!selectedThread?.isCompleted && !selectedThread?.followUpTriggeredOn && selectedThread?.threadTypeId !== 5"
												[disabled]="threadForm.invalid || !threadForm.dirty">Save</button>
											<button type="submit" mat-raised-button (click)="onThreadSave()" *ngIf="selectedThread?.threadTypeId === 5"
												[disabled]="!supportOutForm.dirty || supportOutForm.invalid">Save</button>
											<button type="button" mat-raised-button
												*ngIf="selectedThread && !selectedThread?.isCompleted && selectedThread?.threadTypeId === 2"
												[disabled]="threadForm.dirty"
												(click)="onThreadCompleteClick()">Complete</button>
										</div>
									</div>
								</div>
							</ng-container>

							<ng-container *ngIf="isOnCompleteFollowUp">
								<div class="follow-up-complete">
									<h3>Complete Follow Up</h3>
									<form class="main-form" [formGroup]="completedFollowUpForm">
										<mat-form-field class="container column">
											<mat-label>Complete Comment</mat-label>
											<textarea rows="10" matInput formControlName="completedComment"></textarea>
										</mat-form-field>
									</form>
									<div class="actions">
										<div class="buttons">
											<button type="submit" mat-raised-button (click)="onFollowUpComplete()"
												[disabled]="completedFollowUpForm.invalid">Complete</button>
											<button type="button" mat-raised-button
												(click)="onFollowUpcompleteCancel()">Cancel</button>
										</div>
									</div>
								</div>

							</ng-container>
						</mat-sidenav>
						<mat-sidenav-content>
							<div class="follow-up-header">
								<div class="filters">
									<form [formGroup]="threadSearchForm">
										<mat-form-field>
											<mat-label>Filter</mat-label>
											<mat-select formControlName="filterValues">
												<mat-option *ngFor="let item of filterValues" [value]="item.id">
													{{item.name}}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</form>

									<form [formGroup]="threadFilterForm">
										<mat-form-field>
											<mat-label>Thread Type</mat-label>
											<mat-select formControlName="threadFilterValue">
												<mat-option *ngFor="let item of threadFilterValues" [value]="item.id">
													{{item.name}}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</form>
								</div>
								<button type="button" mat-raised-button class="add-thread-btn" (click)="onAddThread()">
									<mat-icon>add</mat-icon>
									Add Thread
								</button>
							</div>
							<div class="follow-up-table" *ngIf="!isMobileDevice">
								<table mat-table [dataSource]="threadsDataSource">
									<ng-container matColumnDef="thread-type">
										<th mat-header-cell *matHeaderCellDef> Thread Type </th>
										<td mat-cell *matCellDef="let item">
											<span>{{item.threadTypeName}}</span>
										</td>
									</ng-container>
									<ng-container matColumnDef="isCompleted">
										<th mat-header-cell *matHeaderCellDef> Status </th>
										<td mat-cell *matCellDef="let item">
											<span *ngIf="item.isCompleted"
												[class.completed]="item.isCompleted">Completed</span>
											<span *ngIf="!item.isCompleted" [class.open]="!item.isCompleted">Open</span>
										</td>
									</ng-container>

									<ng-container matColumnDef="description">
										<th mat-header-cell *matHeaderCellDef> Note </th>
										<td mat-cell *matCellDef="let item" class="note-td"> {{item.description}}
										</td>
									</ng-container>

									<ng-container matColumnDef="follow-up-by">
										<th mat-header-cell *matHeaderCellDef> Follow Up Date: </th>
										<td mat-cell *matCellDef="let item">
											<span [class.completed]="item.isCompleted" *ngIf="item.threadTypeId === threadTypeEnum.FollowUp">
												{{moment.parseZone(item?.followUpBy).format('MM/DD/YYYY')}}
											</span>
											<span *ngIf="item.threadTypeId !== threadTypeEnum.FollowUp">
												N/A
											</span>
										</td>
									</ng-container>

									<ng-container matColumnDef="requested-by">
										<th mat-header-cell *matHeaderCellDef> Requested By/On: </th>
										<td mat-cell *matCellDef="let item"> {{item.createdBy}}
											({{moment.parseZone(item.createdOn).format('MM/DD/YYYY')}}) </td>
									</ng-container>

									<ng-container matColumnDef="completed-by">
										<th mat-header-cell *matHeaderCellDef> Completed By/On: </th>
										<td mat-cell *matCellDef="let item"> {{item?.completedBy}}
											<span *ngIf="item?.completedOn">
												({{moment.parseZone(item?.completedOn)?.format('MM/DD/YYYY')}})
											</span>
										</td>
									</ng-container>
									<tr class="mat-row" *matNoDataRow>
										<td class="mat-cell" [attr.colspan]="displayedColumns.length">
										  No thread matching the filter.
										</td>
									</tr>
									<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
									<tr mat-row *matRowDef="let row; columns:displayedColumns;"
										(click)="onEditThreadClick(row)"></tr>
								</table>
							</div>
							<ng-container *ngIf="isMobileDevice && documentThreads && documentThreads.length > 0">
								<div class="follow-up-list">
									<div class="follow-up-container" *ngFor="let item of documentThreads"
										(click)="onEditThreadClick(item)">
										<div class="item status">
											<span class="bold">Status: </span>
											<span *ngIf="item.isCompleted" class="bold"
												[class.completed]="item.isCompleted">Completed</span>
											<span *ngIf="!item.isCompleted" class="bold"
												[class.open]="!item.isCompleted">Open</span>
										</div>
										<div class="item note">
											<span class="bold">Note: </span>
											<div>{{item.description}}</div>
										</div>
										<div class="item follow-up-date">
											<span class="bold">Follow Up Date: </span>
											<span [class.completed]="item.isCompleted && item.threadTypeId === threadTypeEnum.FollowUp">{{item.threadTypeId === threadTypeEnum.FollowUp ? moment.parseZone(item.followUpBy).format('MM/DD/YYYY') : 'N/A'}}</span>
										</div>
										<div class="item requested-by">
											<span class="bold">
												Requested By/On:
											</span>
											<span>{{item.createdBy}}
												({{moment.parseZone(item.createdOn).format('MM/DD/YYYY')}})</span>
										</div>
										<div class="item completed-by">
											<span class="bold">Completed By/On:</span>
											<div *ngIf="item?.completedOn">
												<span class="name">{{item?.completedBy}} </span>
												<span>({{moment.parseZone(item?.completedOn)?.format('MM/DD/YYYY')}})</span>
											</div>
										</div>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="isMobileDevice && !documentThreads?.length">
								<p>
									No thread matching the filter.
								</p>
							</ng-container>
						</mat-sidenav-content>
					</mat-sidenav-container>
				</mat-tab>
				<mat-tab text-label="email-summary" *ngIf="managedJobDocuments?.canSeeEmailDetails"
					[disabled]="isUnsavedWork || isOnAddClassification">
					<ng-template mat-tab-label>
						<div *ngIf="isUnsavedWork" class="tab-label" (click)="onTabClick()">
							<span>Email Summary</span>
						</div>
						<span *ngIf="!isUnsavedWork">Email Summary</span>
					</ng-template>
					<div class="email-summary">
						<div class="email-details">
							<span>
								<span class="bold">Name: </span> {{ managedJobDocuments.email.documentName }}
							</span>
							<hr>
							<span>
								<span class="bold">From:</span> {{managedJobDocuments.email.from}}
							</span>
							<span>
								<span class="bold">To:</span> {{getAiEmailRecipients(false)}}
							</span>
							<span>
								<span class="bold">Cc:</span> {{getAiEmailRecipients(true)}}
							</span>
							<span>
								<span class="bold">Subject:</span> {{managedJobDocuments.email.subject || "n/a"}}
							</span>
						</div>
						<hr>
						<div [innerHTML]="managedJobDocuments.email.contentHtml || managedJobDocuments.email.contentText"
							class="email-content">
						</div>
					</div>
				</mat-tab>
			</mat-tab-group>
			<div class="no-managed-document" *ngIf="permissionDenied">
				<p>You cannot manage this document using the provided credentials</p>
			</div>
		</div>
	</ng-template>

	<ng-template #modalActions>
		<div class="modal-actions">
			<p *ngIf="showWarningMessage" class="warning-message">Please save your changes before leaving this tab.</p>
			<div class="buttons">
				<button mat-flat-button (click)="onCancelManageDocumentClick()"
					*ngIf="!isExtended && selectedJobDocument && !permissionDenied && managedJobDocuments.managedJobDocuments.length && !selectedThread || isOnAddClassification"
					[disabled]="isLoading || threadForm.dirty || completedFollowUpForm.dirty">
					<span *ngIf="!isUnsavedWork">Back to Job Documents</span>
					<span *ngIf="!isSidenavOpen && isUnsavedWork && !isExtended">Cancel</span>
				</button>
				<button mat-flat-button (click)="saveManagedDocument()"
					*ngIf="!isExtended && !permissionDenied && selectedJobDocument && selectedTabIndex === 0  && selectedJobDocument?.canEdit && !isSidenavOpen && isUnsavedWork"
					[disabled]="isLoading || documentConclusionOptionSameGroupId !== null">Save</button>
				<button mat-flat-button *ngIf="isOnAddClassification && !isExtended"
					[disabled]="isLoading || addClassificationForm.invalid" (click)="onAddClassificationClick()">
					Save
				</button>
			</div>
		</div>
	</ng-template>
</generic-modal>

<generic-modal #confirmationModal class="confirmation">
	<ng-template #modalBody class="confirmation">Are you sure you want to delete this Classification?</ng-template>
	<ng-template #modalActions>
		<button mat-button (click)="onJobDocumentDeleteConfirmation(); confirmationModal.hide()">Yes</button>
		<button mat-button (click)="confirmationModal.hide()">No</button>
	</ng-template>
</generic-modal>